<template>
    <v-card class="pa-8" rounded="lg" color="primary-gray">
        <v-row>
            <v-col cols="12">
                <v-row align="center">
                    <v-col cols="6">
                        <span id="tour-customers-title" class="text-h4">Clientes</span>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end">
                        <v-btn id="tour-new-customer-btn" elevation="0" color="primary-blue" dark @click="show_add = true">Novo cliente <v-icon right>mdi-account-plus</v-icon></v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-row align="center">
                            <v-col cols="auto">
                                <v-btn id="tour-filters-btn" text @click="show_filter = !show_filter" color="primary">
                                    <v-icon left>mdi-filter</v-icon> Filtros <v-icon right>{{ show_filter ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-divider />
                            </v-col>
                        </v-row>
                        <v-slide-y-transition>
                            <v-row v-if="show_filter" justify="center">
                                <v-col cols="12" md="9">
                                    <v-row>
                                        <v-col cols="6" md="3">
                                            <v-text-field label="Nome" v-model="name" dense clearable></v-text-field>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-text-field label="CPF" v-model="cpf" dense clearable @input="val => cpf = val.replace(/\D/g, '')"></v-text-field>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-text-field label="Email" v-model="email" dense clearable></v-text-field>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-text-field label="Telefone" v-model="phone" dense clearable></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6" md="3">
                                            <v-text-field label="RG" v-model="rg" dense clearable></v-text-field>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-select label="Mês de Aniversário" v-model="birthday_month" dense :items="months" clearable multiple></v-select>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-select label="Tipo de pagamento" v-model="billing_type" dense :items="payment_type_items" clearable></v-select>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-select label="Status do cliente" v-model="status" dense :items="status_items" clearable multiple></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6" md="3">
                                            <v-select label="Frequencia de pagamento" v-model="payment_frequency" dense :items="frequency_type_items" clearable></v-select>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-select label="Frequencia do atendimento" v-model="session_frequency" dense :items="frequency_type_items" clearable></v-select>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-select label="Status do contrato" v-model="signed_contract" dense :items="contract_status_items" clearable></v-select>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-select label="Tem saldo" v-model="balance" dense :items="boolean_items" clearable></v-select>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-slide-y-transition>
                        <v-slide-y-transition>
                            <v-row v-if="show_filter" align="center">
                                <v-col>
                                    <v-divider />
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn color="primary" class="white--text" @click="getCustomers()">
                                        Buscar <v-icon right>mdi-filter-check-outline</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-slide-y-transition>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-row align="center">
                            <v-col cols="auto">
                                <v-btn id="tour-columns-btn" text @click="show_columns = !show_columns" color="primary">
                                    <v-icon left>mdi-view-column</v-icon> Colunas da tabela <v-icon right>{{ show_columns ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-divider />
                            </v-col>
                        </v-row>
                        <v-slide-y-transition>
                            <v-row v-if="show_columns" justify="center">
                                <v-col cols="12">
                                    <v-row justify="center">
                                        <v-col v-for="(column, index) in table_columns" :key="index" cols="auto">
                                            <v-btn small outlined :color="column.show ? 'primary-blue' : 'primary-pink'" :elevation="column.show ? undefined : 0" class="white--text" @click="toggleColumn(column)">{{ column.name }}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-slide-y-transition>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <v-data-table
                    id="tour-customers-table"
                    :headers="headers"
                    :items="customers_list"
                    class="primary-gray"
                    :loading="loading"
                    sort-by="name"
                    item-key="id"
                    :search="search"
                    single-expand
                    show-expand
                    :items-per-page="-1"
                >
                    <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
                        <v-btn
                            :id="item.id === 'tour-fake-customer' ? 'tour-expand-customer' : null"
                            icon
                            @click="expand(!isExpanded)"
                        >
                            <v-icon>{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip small label :style="status_config.color[item.customer_doctor.status]"><v-icon left small>{{ status_config.icon[item.customer_doctor.status] }}</v-icon> {{ status_config.description[item.customer_doctor.status] }}</v-chip>
                    </template>
                    <template v-slot:[`item.contracts_count`]="{ item }">
                        <v-chip small label :style="getAtiveContracts(item.contracts) === 0 ? 'background: linear-gradient(to right bottom, #d87c7b, #c9b6c6);' : 'background: linear-gradient(to right bottom, #8696a7, #cab9bb);'" class="white--text">
                            <v-icon left small class="white--text">{{ getAtiveContracts(item.contracts) > 1 ? 'mdi-file-document-multiple' : (getAtiveContracts(item.contracts) === 0 ? 'mdi-file-remove' : 'mdi-file-document') }}</v-icon>
                            {{ getAtiveContracts(item.contracts) === 0 ? 'Nenhum contrato ativo' : getAtiveContracts(item.contracts) + ' ativo' + (getAtiveContracts(item.contracts) > 1 ? 's' : '')  }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.next_scheduled_session`]="{ item }">
                        {{ item.next_scheduled_session ? formatDate(item.next_scheduled_session.session_date) : 'Não agendado' }}
                    </template>
                    <template v-slot:[`item.cpf`]="{ item }">
                        {{ item.cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") }}
                    </template>
                    <template v-slot:[`item.email`]="{ item }">
                        <a :href="'mailto:' + item.email" target="_blank">{{ item.email }}</a>
                    </template>
                    <template v-slot:[`item.phone`]="{ item }">
                        <a :href="'https://wa.me/+' + item.phone" target="_blank">{{ item.phone?.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4") }}</a>
                    </template>
                    <template v-slot:[`item.birthday`]="{ item }">
                        {{ formatDate(item.birthday) }}
                    </template>
                    <template v-slot:[`item.balance`]="{ item }">
                        <span :class="item.customer_doctor.balance === 0 ? 'error--text' : ''">{{ (item.customer_doctor.balance / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
                    </template>
                    <template v-slot:[`item.ammount`]="{ item }">
                        {{ (item.ammount / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                    </template>
                    <template v-slot:[`item.payday`]="{ item }">
                        {{ formatDate(getNextPayday(item.contracts)) }}
                    </template>
                    <template v-slot:expanded-item="{ headers, item: customer }">
                        <td :colspan="headers.length" class="pa-6" style="background-color: #F5F6FA;">
                            <v-row>
                                <!-- Customer Information Card -->
                                <v-col cols="12" md="5" class="d-flex flex-column">
                                    <v-card id="tour-customer-info-card" class="pa-4 mb-4 fill-height rounded-xl" elevation="0" color="surface">
                                        <v-row class="mb-3">
                                            <v-col>
                                                <div class="d-flex align-center">
                                                    <v-icon color="primary" class="mr-2">mdi-account-circle</v-icon>
                                                    <span class="text-h6 font-weight-bold">Informações do Cliente</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        
                                        <!-- Name and Status -->
                                        <v-row dense class="mb-2">
                                            <v-col cols="12">
                                                <div class="d-flex align-center">
                                                    <v-icon small color="primary" left>mdi-account</v-icon>
                                                    <span class="text-subtitle-1 font-weight-bold">{{ customer.name }}</span>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!-- Contracts and Status Chips -->
                                        <v-row dense class="mb-2">
                                            <v-col v-if="!table_columns.contracts_count?.show && customer.contracts_count" cols="auto">
                                                <v-chip small :color="customer.contracts_count > 0 ? 'primary' : 'error'" class="white--text">
                                                    <v-icon left small class="white--text">{{ customer.contracts_count > 1 ? 'mdi-file-document-multiple' : 'mdi-file-document' }}</v-icon>
                                                    {{ customer.contracts_count }} contrato{{ customer.contracts_count > 1 ? 's' : '' }}
                                                </v-chip>
                                            </v-col>
                                            <v-col v-if="!table_columns.status.show && customer.status" cols="auto">
                                                <v-chip small :style="status_config.color[customer.status]" class="white--text">
                                                    <v-icon left small>{{ status_config.icon[customer.status] }}</v-icon> 
                                                    {{ status_config.description[customer.status] }}
                                                </v-chip>
                                            </v-col>
                                        </v-row>

                                        <v-divider class="my-3"></v-divider>

                                        <!-- Contact Information -->
                                        <v-row dense>
                                            <v-col v-if="!table_columns.cpf.show && customer.cpf" cols="12" md="6" class="text-body-2">
                                                <v-icon small color="primary" left>mdi-card-account-details</v-icon>
                                                {{ customer.cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") }}
                                            </v-col>
                                            <v-col v-if="!table_columns.rg.show && customer.rg" cols="12" md="6" class="text-body-2">
                                                <v-icon small color="primary" left>mdi-card-account-details-outline</v-icon>
                                                RG: {{ customer.rg }}
                                            </v-col>
                                            <v-col v-if="!table_columns.phone.show && customer.phone" cols="12" md="6" class="text-body-2">
                                                <v-icon small color="primary" left>mdi-whatsapp</v-icon>
                                                <a :href="'https://wa.me/+' + customer.phone" target="_blank" class="text-decoration-none primary--text">
                                                    {{ customer.phone?.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4") }}
                                                </a>
                                            </v-col>
                                            <v-col v-if="!table_columns.email.show && customer.email" cols="12" md="6" class="text-body-2">
                                                <v-icon small color="primary" left>mdi-email</v-icon>
                                                <a :href="'mailto:' + customer.email" target="_blank" class="text-decoration-none primary--text">{{ customer.email }}</a>
                                            </v-col>
                                            <v-col v-if="!table_columns.birthday.show && customer.birthday" cols="12" md="6" class="text-body-2">
                                                <v-icon small color="primary" left>mdi-cake-variant</v-icon>
                                                {{ formatDate(customer.birthday) }}
                                            </v-col>
                                            <v-col v-if="!table_columns.next_scheduled_session?.show && customer.next_scheduled_session" cols="12" md="6" class="text-body-2">
                                                <v-icon small color="primary" left>mdi-calendar-clock</v-icon>
                                                Próx: {{ formatDate(customer.next_scheduled_session.session_date) }}
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>

                                <!-- Performance Card -->
                                <v-col cols="12" md="5" class="d-flex flex-column">
                                    <v-card id="tour-customer-performance-card" class="pa-4 mb-4 fill-height rounded-xl" elevation="0" color="surface">
                                        <v-row class="mb-3">
                                            <v-col>
                                                <div class="d-flex align-center">
                                                    <v-icon color="primary" class="mr-2">mdi-chart-donut</v-icon>
                                                    <span class="text-h6 font-weight-bold">Desempenho</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-card v-if="getAttendedSessionsCount(customer.sessions) + getMissedSessionsCount(customer.sessions) + getRescheduledSessionsCount(customer.sessions)" elevation="0" height="50" class="rounded-lg d-flex nowrap overflow-hidden">
                                                    <v-tooltip top color="event-attended">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-card
                                                                elevation="0"
                                                                class="event-attended rounded-0 d-flex align-center justify-center"
                                                                dark
                                                                height="100%"
                                                                :width="((getAttendedSessionsCount(customer.sessions) / (getAttendedSessionsCount(customer.sessions) + getMissedSessionsCount(customer.sessions) + getRescheduledSessionsCount(customer.sessions))) * 100) + '%'"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <span class="font-weight-bold">{{ Math.round((getAttendedSessionsCount(customer.sessions) / (getAttendedSessionsCount(customer.sessions) + getMissedSessionsCount(customer.sessions) + getRescheduledSessionsCount(customer.sessions))) * 100) }}%</span>
                                                            </v-card>
                                                        </template>
                                                        <span class="font-weight-bold">Compareceu: {{ getAttendedSessionsCount(customer.sessions) }} atendimentos</span>
                                                    </v-tooltip>
                                                    <v-tooltip top color="event-missed">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-card
                                                                elevation="0"
                                                                class="event-missed rounded-0 d-flex align-center justify-center"
                                                                dark height="100%"
                                                                :width="((getMissedSessionsCount(customer.sessions) / (getAttendedSessionsCount(customer.sessions) + getMissedSessionsCount(customer.sessions) + getRescheduledSessionsCount(customer.sessions))) * 100) + '%'"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <span v-if="getMissedSessionsCount(customer.sessions)" class="font-weight-bold">{{ Math.round((getMissedSessionsCount(customer.sessions) / (getAttendedSessionsCount(customer.sessions) + getMissedSessionsCount(customer.sessions) + getRescheduledSessionsCount(customer.sessions))) * 100) }}%</span>
                                                            </v-card>
                                                        </template>
                                                        <span class="font-weight-bold">Faltou: {{ getMissedSessionsCount(customer.sessions) }} atendimentos</span>
                                                    </v-tooltip>
                                                    <v-tooltip top color="event-rescheduled">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-card
                                                                elevation="0"
                                                                class="event-rescheduled rounded-0 d-flex align-center justify-center"
                                                                dark height="100%"
                                                                :width="((getRescheduledSessionsCount(customer.sessions) / (getAttendedSessionsCount(customer.sessions) + getMissedSessionsCount(customer.sessions) + getRescheduledSessionsCount(customer.sessions))) * 100) + '%'"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <span v-if="getRescheduledSessionsCount(customer.sessions)" class="font-weight-bold">{{ Math.round((getRescheduledSessionsCount(customer.sessions) / (getAttendedSessionsCount(customer.sessions) + getMissedSessionsCount(customer.sessions) + getRescheduledSessionsCount(customer.sessions))) * 100) }}%</span>
                                                            </v-card>
                                                        </template>
                                                        <span class="font-weight-bold">Remarcou: {{ getRescheduledSessionsCount(customer.sessions) }} atendimentos</span>
                                                    </v-tooltip>
                                                </v-card>
                                                <div v-else class="text-center text--secondary py-4">
                                                    <v-icon color="grey">mdi-chart-line-variant</v-icon>
                                                    <div class="text-caption mt-2">Nenhum atendimento registrado</div>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        
                                        <!-- Legend -->
                                        <v-row dense class="mt-3">
                                            <v-col cols="12">
                                                <div class="d-flex flex-wrap justify-center">
                                                    <v-chip x-small color="event-attended" class="white--text ma-1">
                                                        <v-icon x-small left>mdi-check-circle</v-icon>
                                                        Compareceu
                                                    </v-chip>
                                                    <v-chip x-small color="event-missed" class="white--text ma-1">
                                                        <v-icon x-small left>mdi-close-circle</v-icon>
                                                        Faltou
                                                    </v-chip>
                                                    <v-chip x-small color="event-rescheduled" class="white--text ma-1">
                                                        <v-icon x-small left>mdi-calendar-refresh</v-icon>
                                                        Remarcou
                                                    </v-chip>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>

                                <!-- Balance Card -->
                                <v-col v-if="!table_columns.balance.show" cols="12" md="2" class="d-flex flex-column">
                                    <v-card id="tour-customer-balance-card" class="pa-4 mb-4 fill-height rounded-xl" elevation="0" :color="customer.customer_doctor.balance < 0 ? 'error' : (customer.customer_doctor.balance === 0 ? 'event-payment-pending' : 'green')">
                                        <v-row class="mb-2">
                                            <v-col>
                                                <div class="d-flex align-center">
                                                    <v-icon color="white" class="mr-2">mdi-cash-multiple</v-icon>
                                                    <span class="text-subtitle-1 font-weight-bold white--text">Saldo</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row class="fill-height d-flex align-center mt-n8">
                                            <v-col class="text-center">
                                                <div class="text-h4 font-weight-bold white--text">
                                                    {{ (customer.customer_doctor.balance / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                            
                            <!-- Comments Card -->
                            <v-card v-if="customer.customer_doctor.comments" class="pa-4 mb-4 rounded-xl" elevation="0" color="surface">
                                <v-row class="mb-2">
                                    <v-col>
                                        <div class="d-flex align-center">
                                            <v-icon color="primary" class="mr-2">mdi-comment-text</v-icon>
                                            <span class="text-h6 font-weight-bold">Observações</span>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div class="text-body-2 text-pre">{{ customer.customer_doctor.comments }}</div>
                                    </v-col>
                                </v-row>
                            </v-card>

                            <!-- Notification Settings Card (Pro Only) -->
                            <v-card id="tour-customer-notifications-card" v-if="isPro || isSysAdmin" class="pa-4 mb-4 rounded-xl" elevation="0" color="surface">
                                <v-row class="mb-2">
                                    <v-col>
                                        <div class="d-flex align-center">
                                            <v-icon color="primary" class="mr-2">mdi-bell-cog</v-icon>
                                            <span class="text-h6 font-weight-bold">Configurações de Notificações</span>
                                            <v-chip x-small color="primary" class="ml-2 white--text">Premium</v-chip>
                                        </div>
                                    </v-col>
                                </v-row>
                                
                                <!-- Appointment Notifications -->
                                <v-row dense class="mb-2">
                                    <v-col cols="12">
                                        <div class="text-subtitle-2 font-weight-bold mb-2">
                                            <v-icon small color="primary" left>mdi-calendar-clock</v-icon>
                                            Notificações de Agendamento
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-switch
                                            :input-value="customer.customer_doctor.app_notifications_enabled"
                                            @change="updateNotificationSettings(customer, 'app_notifications_enabled', $event)"
                                            label="App Mobile"
                                            color="primary"
                                            dense
                                            hide-details
                                            class="mt-0"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-switch
                                            :input-value="customer.customer_doctor.whatsapp_notifications_enabled"
                                            @change="updateNotificationSettings(customer, 'whatsapp_notifications_enabled', $event)"
                                            label="WhatsApp"
                                            color="primary"
                                            dense
                                            hide-details
                                            class="mt-0"
                                        ></v-switch>
                                    </v-col>
                                </v-row>

                                <v-divider class="my-3"></v-divider>

                                <!-- Payment Notifications -->
                                <v-row dense>
                                    <v-col cols="12">
                                        <div class="text-subtitle-2 font-weight-bold mb-2">
                                            <v-icon small color="primary" left>mdi-cash-clock</v-icon>
                                            Notificações de Pagamento
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-switch
                                            :input-value="customer.customer_doctor.payment_app_notifications_enabled"
                                            @change="updateNotificationSettings(customer, 'payment_app_notifications_enabled', $event)"
                                            label="App Mobile"
                                            color="primary"
                                            dense
                                            hide-details
                                            class="mt-0"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-switch
                                            :input-value="customer.customer_doctor.payment_whatsapp_notifications_enabled"
                                            @change="updateNotificationSettings(customer, 'payment_whatsapp_notifications_enabled', $event)"
                                            label="WhatsApp"
                                            color="primary"
                                            dense
                                            hide-details
                                            class="mt-0"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                            </v-card>

                            <!-- Contracts Card -->
                            <v-card id="tour-customer-contracts-card" class="pa-4 rounded-xl" elevation="0" color="surface">
                                <v-row class="mb-3">
                                    <v-col>
                                        <div class="d-flex align-center">
                                            <v-icon color="primary" class="mr-2">mdi-file-document-multiple</v-icon>
                                            <span class="text-h6 font-weight-bold">Contratos</span>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-data-table
                                            :headers="[
                                                { text: 'Serviço', value: 'service' },
                                                { text: 'Duração', value: 'attendance_duration' },
                                                { text: 'Freq. Atend.', value: 'attendance_frequency' },
                                                { text: 'Valor', value: 'attendance_value' },
                                                { text: 'Faturamento', value: 'billing_type' },
                                                { text: 'Próx. Pag.', value: 'payday' },
                                                { text: 'Freq. Pag.', value: 'payment_frequency' },
                                                { text: 'Dia', value: 'week_day_attendance' },
                                                { text: 'Horário', value: 'hour_attendance' },
                                                { text: 'Status', value: 'signed' },
                                                { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
                                            ]"
                                            :items="customer.contracts"
                                            class="elevation-0"
                                            :loading="loading"
                                            sort-by="service"
                                            item-key="id"
                                            :items-per-page="-1"
                                            hide-default-footer
                                        >
                                            <template v-slot:[`item.service`]="{ item }">
                                                <div class="d-flex align-center">
                                                    <v-icon small color="primary" class="mr-2">mdi-clipboard-text</v-icon>
                                                    <span class="font-weight-medium">{{ item.service.name }}</span>
                                                </div>
                                            </template>
                                            <template v-slot:[`item.attendance_duration`]="{ item }">
                                                <v-chip small outlined color="primary">
                                                    <v-icon small left>mdi-clock-outline</v-icon>
                                                    {{ item.attendance_duration }}min
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.attendance_frequency`]="{ item }">
                                                <v-chip small :color="frequency_config.color[item.attendance_frequency]" class="white--text">
                                                    <v-icon small left class="white--text">{{ frequency_config.icon[item.attendance_frequency] }}</v-icon>
                                                    {{ frequency_config.description[item.attendance_frequency] }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.attendance_value`]="{ item }">
                                                <span class="font-weight-bold primary--text">
                                                    {{ (item.attendance_value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                                                </span>
                                            </template>
                                            <template v-slot:[`item.billing_type`]="{ item }">
                                                <v-chip small outlined :color="item.billing_type === 'A' ? 'primary' : 'secondary'">
                                                    <v-icon small left>{{ item.billing_type === 'A' ? 'mdi-cash' : 'mdi-calendar-month' }}</v-icon>
                                                    {{ item.billing_type === 'A' ? 'Por atend.' : 'Mensal' }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.payday`]="{ item }">
                                                <div class="d-flex align-center">
                                                    <v-icon small color="grey" class="mr-1">mdi-calendar</v-icon>
                                                    {{ formatDate(item.payday) }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.payment_frequency`]="{ item }">
                                                <v-chip small :color="frequency_config.color[item.payment_frequency]" class="white--text">
                                                    <v-icon small left class="white--text">{{ frequency_config.icon[item.payment_frequency] }}</v-icon>
                                                    {{ frequency_config.description[item.payment_frequency] }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.week_day_attendance`]="{ item }">
                                                {{ week_day_description[item.week_day_attendance] }}
                                            </template>
                                            <template v-slot:[`item.hour_attendance`]="{ item }">
                                                <div class="d-flex align-center">
                                                    <v-icon small color="grey" class="mr-1">mdi-clock</v-icon>
                                                    {{ item.hour_attendance }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.signed`]="{ item }">
                                                <v-chip small :color="signed_config.color[item.status]" class="white--text">
                                                    <v-icon small left class="white--text">{{ signed_config.icon[item.status] }}</v-icon>
                                                    {{ signed_config.description[item.status] }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.actions`]="{ item }">
                                                <div class="d-flex justify-center">
                                                    <v-tooltip top color="primary">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon small @click="updateContract(item, customer)" color="primary" v-bind="attrs" v-on="on">
                                                                <v-icon small>mdi-file-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Detalhes</span>
                                                    </v-tooltip>
                                                    
                                                    <v-tooltip v-if="item.status === 'P'" top color="secondary">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon small @click="signContract(item)" color="secondary" v-bind="attrs" v-on="on">
                                                                <v-icon small>mdi-file-sign</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Assinar</span>
                                                    </v-tooltip>
                                                    
                                                    <v-tooltip v-if="item.status === 'A' && !item.signed_contract_file_path" top color="primary">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon small @click="uploadSignedContract(item)" color="primary" v-bind="attrs" v-on="on">
                                                                <v-icon small>mdi-file-upload</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Upload do arquivo assinado</span>
                                                    </v-tooltip>
                                                    
                                                    <v-tooltip v-if="item.status !== 'C' && item.status !== 'E'" top color="error">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon small @click="cancelContract(item)" color="error" v-bind="attrs" v-on="on">
                                                                <v-icon small>mdi-close-circle</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Cancelar</span>
                                                    </v-tooltip>
                                                    
                                                    <v-tooltip v-if="item.status === 'A'" top color="secondary">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon small @click="finishContract(item, customer)" color="secondary" v-bind="attrs" v-on="on">
                                                                <v-icon small>mdi-archive</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Encerrar</span>
                                                    </v-tooltip>
                                                    
                                                    <v-tooltip v-if="item.status !== 'C' && (item.signed_contract_file_path || item.status === 'P')" top color="primary">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon small @click="generatePDF(item, customer)" color="primary" v-bind="attrs" v-on="on" :loading="customer.loading_contract" :disabled="customer.loading_contract">
                                                                <v-icon small>mdi-download</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Baixar PDF</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                            
                                            <template v-slot:no-data>
                                                <div class="text-center py-8">
                                                    <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                                                    <div class="text-h6 grey--text mt-2">Nenhum contrato encontrado</div>
                                                    <div class="text-caption grey--text">Clique em "Novo contrato" para começar</div>
                                                </div>
                                            </template>
                                        </v-data-table>
                                        <v-row justify="start" class="mt-2">
                                            <v-col cols="auto">
                                                <v-btn color="primary" class="white--text" :disabled="noNewContractAvailable(customer.contracts)" @click="generateContract(customer)">
                                                    Novo contrato <v-icon right>mdi-hammer-wrench</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </td>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-row :id="item.id === 'tour-fake-customer' ? 'tour-customer-actions' : null" no-gutters class="flex-nowrap">
                            <v-col cols="auto" class="px-1">
                                <v-tooltip top color="orange">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click="showEmergencyContacts(item)" color="orange" v-bind="attrs" v-on="on">
                                            <v-icon>
                                                mdi-human-greeting-proximity
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    Contatos de emergência
                                </v-tooltip>
                            </v-col>
                            <v-col cols="auto" class="px-1">
                                <v-tooltip top color="primary-blue">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click="showSessions(item)" color="primary-blue" v-bind="attrs" v-on="on" :id="item.id === 'tour-fake-customer' ? 'tour-customer-list-sessions' : null">
                                            <v-icon>
                                                mdi-list-box-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    Lista de atendimentos
                                </v-tooltip>
                            </v-col>
                            <v-col cols="auto" class="px-1">
                                <v-tooltip top color="secondary-blue">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click="showPayments(item)" color="secondary-blue" v-bind="attrs" v-on="on">
                                            <v-icon>
                                                mdi-list-box-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    Lista de pagamentos
                                </v-tooltip>
                            </v-col>
                            <v-col cols="auto" class="px-1">
                                <v-tooltip top color="blue">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click="edit(item)" color="blue" v-bind="attrs" v-on="on">
                                            <v-icon>
                                                mdi-account-edit
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    Editar
                                </v-tooltip>
                            </v-col>
                            <v-col cols="auto" class="px-1">
                                <v-tooltip top color="error darken-4">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click="disable(item)" color="error darken-4" v-bind="attrs" v-on="on">
                                            <v-icon>
                                                mdi-account-remove
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    Deletar
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <dialog-add-customer v-model="show_add" @created="getCustomers" />
        <dialog-edit-customer v-model="show_edit" :customer-data="customer_selected" @edited="getCustomers" @close="customer_selected = null" />
        <dialog-delete-customer v-model="show_delete" :customer-data="customer_selected" @deleted="getCustomers" @close="customer_selected = null" />
        <dialog-list-sessions v-model="show_sessions" :customer-data="customer_selected" @close="customer_selected = null" @updateData="getCustomers"/>
        <dialog-list-emergency-contacts v-model="show_emergency_contacts" :customer-data="customer_selected" @close="customer_selected = null"/>
        <dialog-list-payments v-model="show_list_customer_payments" :customer-data="customer_selected" @close="show_list_customer_payments = null" @updateData="getCustomers" />
        <dialog-generate-contract v-model="show_generate_contract" :customer="customer_selected" :contract-data="contract_selected" :count-by-service="countPendingOrActiveContractsGroupByServiceType(customer_selected?.contracts ?? [])" @close="closeContractDialog()" @created="getCustomers" />
        <dialog-sign-contract v-model="show_sign_contract" :contract-data="contract_selected" @close="contract_selected = null" @signed="getCustomers" />
        <dialog-upload-signed-contract v-model="show_upload_signed_contract" :contract-data="contract_selected" @close="contract_selected = null" @uploaded="getCustomers" />
        <dialog-cancel-contract v-model="show_cancel_contract" :contract-data="contract_selected" @close="contract_selected = null" @canceled="getCustomers" />
        <dialog-finish-contract v-model="show_finish_contract" :contract-data="contract_selected" @close="contract_selected = null" @finished="getCustomers" />
    </v-card>
</template>

<script>
import dayjs from 'dayjs';
import localeData from "dayjs/plugin/localeData";
import { api } from '@/http/index';
import DialogAddCustomer from './components/DialogAddCustomer.vue';
import DialogEditCustomer from './components/DialogEditCustomer.vue';
import DialogDeleteCustomer from './components/DialogDeleteCustomer.vue';
import DialogListSessions from '../sessions/components/DialogListSessions.vue';
import DialogListEmergencyContacts from './components/DialogListEmergencyContacts.vue';
import DialogListPayments from '../extract/components/DialogListPayments.vue';
import DialogGenerateContract from './components/DialogGenerateContract.vue';
import DialogSignContract from './components/DialogSignContract.vue';
import DialogUploadSignedContract from './components/DialogUploadSignedContract.vue';
import DialogCancelContract from './components/DialogCancelContract.vue';
import DialogFinishContract from './components/DialogFinishContract.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import NotificationService from '../notifications/services/notifications';
import profileLimits from '@/mixins/profileLimits';

export default {
    components: {
        DialogAddCustomer,
        DialogEditCustomer,
        DialogDeleteCustomer,
        DialogListSessions,
        DialogListEmergencyContacts,
        DialogListPayments,
        DialogGenerateContract,
        DialogSignContract,
        DialogUploadSignedContract,
        DialogCancelContract,
        DialogFinishContract
    },
    mixins: [profileLimits],
    data() {
        return {
            headers: [
                { text: "Nome", value: "name" },
                { text: "Status", value: "status" },
                { text: "Contratos ativos", value: "contracts_count" },
                { text: "Próx. atendimento", value: "next_scheduled_session" },
                { text: '', value: 'data-table-expand', sortable: false },
                { text: '', value: 'actions', sortable: false },
            ],
            show_columns: false,
            loading: false,
            search: "",
            show_add: false,
            signed_config: {
                description: {
                    "A": "Assinado",
                    "P": "Não assinado",
                    "C": "Cancelado",
                    "E": "Encerrado"
                },
                color: {
                    "A": "primary-blue",
                    "P": "secondary-yellow",
                    "C": "secondary-red",
                    "E": "primary-pink"
                },
                icon: {
                    "A": "mdi-check-circle",
                    "P": "mdi-alert-circle",
                    "C": "mdi-close-circle",
                    "E": "mdi-circle"
                }
            },
            status_config: {
                description: {
                    P: "Primeiro contato",
                    A: "Cliente ativo",
                    I: "Cliente inativo"
                },
                color: {
                    P: "background: linear-gradient(to right bottom, #8696a7, #c9b6c6);",
                    A: "background: linear-gradient(to right bottom, #9dbcc1, #f1e3c6);",
                    I: "background: linear-gradient(to right bottom, #a5a5a5, #d8d8d8);"
                },
                icon: {
                    P: "mdi-account-clock",
                    A: "mdi-account-check",
                    I: "mdi-account-cancel"
                }
            },
            frequency_config: {
                description: {
                    M: "Mensal",
                    Q: "Quinzenal",
                    S: "Semanal"
                },
                color: {
                    M: "purple",
                    Q: "deep-purple",
                    S: "teal"
                },
                icon: {
                    M: "mdi-calendar-month",
                    Q: "mdi-calendar-text",
                    S: "mdi-calendar-week"
                }
            },
            week_day_description: {
                monday: 'Segunda-feira',
                tuesday: 'Terça-feira',
                wednesday: 'Quarta-feira',
                thursday: 'Quinta-feira',
                friday: 'Sexta-feira',
                saturday: 'Sábado',
                sunday: 'Domingo'
            },
            customer_selected: null,
            contract_selected: null,
            show_edit: false,
            show_delete: false,
            show_sessions: false,
            show_emergency_contacts: false,
            show_generate_contract: false,
            show_sign_contract: false,
            show_upload_signed_contract: false,
            show_cancel_contract: false,
            show_finish_contract: false,
            show_list_customer_payments: false,
            show_filter: false,
            months: [
                { value: '01', text: 'Janeiro' },
                { value: '02', text: 'Fevereiro' },
                { value: '03', text: 'Março' },
                { value: '04', text: 'Abril' },
                { value: '05', text: 'Maio' },
                { value: '06', text: 'Junho' },
                { value: '07', text: 'Julho' },
                { value: '08', text: 'Agosto' },
                { value: '09', text: 'Setembro' },
                { value: '10', text: 'Outubro' },
                { value: '11', text: 'Novembro' },
                { value: '12', text: 'Dezembro' }
            ],
            payment_type_items: [
                { value: 'M', text: "Mensal" },
                { value: 'A', text: "Por atendimento" },
            ],
            frequency_type_items: [
                { value: 'M', text: "Mensal" },
                { value: 'Q', text: "Quinzenal" },
                { value: 'S', text: "Semanal" }
            ],
            status_items: [
                { value: 'P', text: "Primeiro contato" },
                { value: 'A', text: "Cliente ativo" },
                { value: 'I', text: "Cliente inativo" }
            ],
            contract_status_items: [
                { value: 'P', text: "Pendente de assinatura" },
                { value: 'A', text: "Ativo" },
                { value: 'C', text: "Cancelado" },
                { value: 'E', text: "Encerrado" }
            ],
            boolean_items: [
                { value: true, text: "Sim" },
                { value: false, text: "Não" }
            ],
            name: null,
            cpf: null,
            email: null,
            phone: null,
            birthday_month: null,
            billing_type: null,
            status: ['A', 'P'],
            payment_frequency: null,
            session_frequency: null,
            rg: null,
            balance: null,
            signed_contract: null,
            customers_list: [],
            table_columns: {
                name: { text: "Nome", value: "name", name: "Nome", show: true },
                cpf: { text: "CPF", value: "cpf", name: "CPF", show: false },
                rg: { text: "RG", value: "rg", name: "RG", show: false },
                email: { text: "Email", value: "email", name: "Email", show: false },
                phone: { text: "Telefone", value: "phone", name: "Telefone", show: false },
                birthday: { text: "Data de nascimento", value: "birthday", name: "Data de nascimento", show: false },
                balance: { text: "Saldo do cliente", value: "balance", name: "Saldo do cliente", show: false },
                status: { text: "Status", value: "status", name: "Status", show: true },
                contracts_count: { text: "Contratos ativos", value: "contracts_count", name: "Contratos ativos", show: true },
                next_scheduled_session: { text: "Próx. atendimento", value: "next_scheduled_session", name: "Próx. atendimento", show: true },
                payday: { text: "Data do próx. pagamento", value: "payday", name: "Data do próx. pagamento", show: false },
                'data-table-expand': { text: '', value: 'data-table-expand', sortable: false, name: "Expandir informações", show: true },
                actions: { text: '', value: 'actions', sortable: false, name: "Ações", show: true },
            },
        };
    },
    computed: {
        ...mapGetters('auth', ['isPro', 'isSysAdmin']),
        ...mapState('auth', ['user']),
    },
    mounted() {
        dayjs.extend(require('dayjs/plugin/customParseFormat'));
        dayjs.extend(localeData);
        dayjs.locale('pt-br');
        this.getCustomers();

        let local_storage = false /* window.localStorage.getItem('table_columns') */;
        if (local_storage) {
            this.table_columns = JSON.parse(local_storage);
            this.mountColumns();
        }

        // Expose methods for tour
        window.$customersPage = this;
    },
    beforeDestroy() {
        // Clean up global reference
        if (window.$customersPage === this) {
            window.$customersPage = null;
        }
    },
    methods: {
        ...mapActions("customers", ["ActionDoGetCustomers", "ActionDoGetSignedContract"]),
        getCustomers() {
            this.loading = true;
            this.ActionDoGetCustomers(this.mountFilter()).then((customers) => {
                this.customers_list = customers;
                if (this.customer_selected) {
                    this.customer_selected = customers.find((customer) => customer.id === this.customer_selected.id);
                }
                this.loading = false;
            });
        },
        getAtiveContracts(contractList) {
            return contractList.filter(contract => contract.status === 'A').length;
        },
        countPendingOrActiveContractsGroupByServiceType(contractList) {
            return contractList.reduce((acc, contract) => {
                if (contract.status === 'A' || contract.status === 'P') {
                    const serviceType = contract.service_id;
                    if (acc[serviceType]) {
                        acc[serviceType]++;
                    } else {
                        acc[serviceType] = 1;
                    }
                }
                return acc;
            }, {});
        },
        noNewContractAvailable(contractList) {
            let contract_by_service = this.countPendingOrActiveContractsGroupByServiceType(contractList);
            return Object.values(contract_by_service).length === 2 && Object.values(contract_by_service).every(value => value === 1) ? true : false;
        },
        mountFilter() {
            let filter = {};

            if (this.name) {
                filter['name'] = this.name;
            }
            if (this.cpf) {
                filter['cpf'] = this.cpf;
            }
            if (this.email) {
                filter['email'] = this.email;
            }
            if (this.phone) {
                filter['phone'] = this.phone;
            }
            if (this.birthday_month) {
                filter['birthday_month'] = this.birthday_month;
            }
            if (this.billing_type) {
                filter['billing_type'] = this.billing_type;
            }
            if (this.payment_frequency) {
                filter['payment_frequency'] = this.payment_frequency;
            }
            if (this.session_frequency) {
                filter['session_frequency'] = this.session_frequency;
            }
            if (this.status) {
                filter['status'] = this.status;
            }
            if (this.rg) {
                filter['rg'] = this.rg;
            }
            if (this.balance !== null) {
                filter['balance'] = this.balance;
            }
            if (this.signed_contract !== null) {
                filter['signed_contract'] = this.signed_contract;
            }

            return Object.values(filter).length > 0 ? filter : null;
        },
        formatDate(date) {
            return date ? dayjs(date).format('DD/MM/YYYY') : "-";
        },
        edit(customer) {
            this.customer_selected = customer;
            this.show_edit = true;
        },
        disable(customer) {
            this.customer_selected = customer;
            this.show_delete = true;
        },
        showSessions(customer) {
            this.customer_selected = customer;
            this.show_sessions = true;
        },
        showPayments(customer) {
            this.customer_selected = customer;
            this.show_list_customer_payments = true;
        },
        showEmergencyContacts(customer) {
            this.customer_selected = customer;
            this.show_emergency_contacts = true;
        },
        generateContract(customer) {
            this.customer_selected = customer;
            this.show_generate_contract = true;
        },
        updateContract(contract, customer) {
            this.contract_selected = contract;
            this.customer_selected = customer;
            this.show_generate_contract = true;
        },
        closeContractDialog() {
            this.customer_selected = null;
            this.contract_selected = null;
            this.show_generate_contract = false;
        },
        signContract(contract) {
            this.contract_selected = contract;
            this.show_sign_contract = true;
        },
        uploadSignedContract(contract) {
            this.contract_selected = contract;
            this.show_upload_signed_contract = true;
        },
        cancelContract(contract) {
            this.contract_selected = contract;
            this.show_cancel_contract = true;
        },
        finishContract(contract) {
            this.contract_selected = contract;
            this.show_finish_contract = true;
        },
        async generatePDF(contract, customer) {
            if (['A', 'E'].includes(contract.status)) {
                this.ActionDoGetSignedContract(contract.id).then(({temporary_path}) => {
                    window.open(temporary_path, '_blank');
                });
            } else {
                customer.loading_contract = true;
                this.$forceUpdate();

                api.get('/contract/contracts/' + contract.id + '/pdf', {
                    responseType: 'blob'
                }).then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Contrato_' + (customer.name ? customer.name.replace(/[^a-zA-Z0-9]/g, '_') : 'documento') + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                    window.setTimeout(() => window.URL.revokeObjectURL(url), 100);
                }).catch(err => {
                    console.error('Error generating PDF:', err);
                    if (this.$toast) {
                        this.$toast.error('Erro ao gerar o PDF do contrato.');
                    }
                }).finally(() => {
                    customer.loading_contract = false;
                    this.$forceUpdate();
                });
            }
        },
        toggleColumn(column) {
            column.show = !column.show;
            /* window.localStorage.setItem('table_columns', JSON.stringify(this.table_columns)); */
            this.mountColumns();
        },
        mountColumns() {
            let new_headers = [];

            for (let column in this.table_columns) {
                if (this.table_columns[column].show) {
                    new_headers.push(this.table_columns[column]);
                }
            }

            this.headers = new_headers;
        },
        getNextPayday(contracts) {
            let next_payday = null;
            for (let contract of contracts) {
                if (contract.payday) {
                    if (!next_payday || contract.payday < next_payday) {
                        next_payday = contract.payday;
                    }
                }
            }

            return next_payday;
        },
        getAttendedSessionsCount(sessions) {
            if (!sessions || !Array.isArray(sessions)) return 0;
            return sessions.filter(session => session.attended === true && session.finished === true && session.rescheduled === false).length;
        },
        getMissedSessionsCount(sessions) {
            if (!sessions || !Array.isArray(sessions)) return 0;
            return sessions.filter(session => session.attended === false && session.finished === true && session.rescheduled === false).length;
        },
        getRescheduledSessionsCount(sessions) {
            if (!sessions || !Array.isArray(sessions)) return 0;
            return sessions.filter(session => session.rescheduled === true).length;
        },
        getBalanceStatus(balance) {
            if (balance < 0) return 'Negativo';
            if (balance === 0) return 'Zerado';
            return '';
        },
        async updateNotificationSettings(customer, field, value) {
            try {
                const payload = {
                    [field]: value
                };
                
                await NotificationService.updateCustomerNotifications(
                    customer.customer_doctor.id,
                    payload
                );
                
                // Update local data
                customer.customer_doctor[field] = value;
                
                this.$swal({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'Configurações de notificação atualizadas',
                    timer: 2000,
                    showConfirmButton: false
                });
            } catch (error) {
                console.error('Error updating notification settings:', error);
                this.$swal({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Erro ao atualizar configurações de notificação',
                    confirmButtonText: 'OK'
                });
                
                // Refresh to restore correct state
                this.getCustomers();
            }
        },
        addFakeCustomerForTour() {
            const fakeCustomer = {
                id: 'tour-fake-customer',
                name: 'Maria Silva (Tour)',
                cpf: '12345678900',
                rg: '1234567',
                email: 'maria.silva@example.com',
                phone: '5511987654321',
                birthday: '1990-05-15',
                customer_doctor: {
                    id: 'tour-fake-cd',
                    status: 'A',
                    balance: 15000,
                    comments: 'Cliente exemplo para demonstração do tour.',
                    app_notifications_enabled: true,
                    whatsapp_notifications_enabled: true,
                    payment_app_notifications_enabled: false,
                    payment_whatsapp_notifications_enabled: true
                },
                contracts: [
                    {
                        id: 'tour-fake-contract-1',
                        service: { name: 'Psicoterapia Individual' },
                        service_id: 1,
                        attendance_duration: 50,
                        attendance_frequency: 'S',
                        attendance_value: 20000,
                        billing_type: 'M',
                        payment_frequency: 'M',
                        week_day_attendance: 'monday',
                        hour_attendance: '14:00',
                        status: 'A',
                        payday: '2026-02-05',
                        signed_contract_file_path: null
                    }
                ],
                contracts_count: 1,
                next_scheduled_session: {
                    session_date: '2026-01-22T14:00:00'
                },
                sessions: [
                    { id: 'tour-fake-session-2', attended: true, finished: true, rescheduled: false, session_date: '2025-12-01', service: { name: 'Psicoterapia' }, session_duration: 50, session_value: 20000, comments: 'Paciente estável.' },
                    { attended: true, finished: true, rescheduled: false, session_date: '2025-11-20', service: { name: 'Psicoterapia' }, session_duration: 50, session_value: 20000 },
                    { attended: true, finished: true, rescheduled: false, session_date: '2025-11-10', service: { name: 'Psicoterapia' }, session_duration: 50, session_value: 20000 },
                    { attended: true, finished: true, rescheduled: false },
                    { attended: false, finished: true, rescheduled: false },
                    { attended: false, finished: false, rescheduled: true }
                ]
            };
            
            this.customers_list.unshift(fakeCustomer);
            console.log('[Tour] Fake customer added to list');
        },
        removeFakeCustomerForTour() {
            const index = this.customers_list.findIndex(c => c.id === 'tour-fake-customer');
            if (index !== -1) {
                this.customers_list.splice(index, 1);
                console.log('[Tour] Fake customer removed from list');
            }
        },
        expandFakeCustomerForTour() {
            this.$nextTick(() => {
                const expandBtn = document.querySelector('#tour-expand-customer');
                if (expandBtn) {
                    expandBtn.click();
                    console.log('[Tour] Fake customer row expanded');
                } else {
                    console.warn('[Tour] Expand button not found');
                }
            });
        }
    }
};
</script>
